/**
 * All available colors in the sysarb graphical profile.
 * If any color is missing, please add it here.
 */
export enum SysarbColors {
    // System colors
    GRAY_100 = '#F6F7F7',
    GRAY_200 = '#EAEBEB',
    GRAY_300 = '#D0D2D2',
    GRAY_400 = '#B8BCBD',
    GRAY_500 = '#8B9092',
    GRAY_600 = '#717679',
    GRAY_700 = '#545759',
    GRAY_800 = '#3F4447',
    GRAY_900 = '#292D30',

    BLUE_100 = '#EAF2FA',
    BLUE_200 = '#D6E6F5',
    BLUE_300 = '#B9D5EE',
    BLUE_400 = '#90BCE4',
    BLUE_500 = '#5296D5',
    BLUE_600 = '#2D75B9',
    BLUE_700 = '#235B90',
    BLUE_800 = '#1B466F',
    BLUE_900 = '#0F273D',

    RED_100 = '#F9ECEC',
    RED_200 = '#F4DADB',
    RED_300 = '#ECBEBF',
    RED_400 = '#E3A0A2',
    RED_500 = '#D67174',
    RED_600 = '#C1464A',
    RED_700 = '#943134',
    RED_800 = '#6F2528',
    RED_900 = '#4E1316',

    ORANGE_100 = '#FBF1E9',
    ORANGE_200 = '#F5DFCC',
    ORANGE_300 = '#ECC29D',
    ORANGE_400 = '#E19F65',
    ORANGE_500 = '#D67C2E',
    ORANGE_600 = '#AA6122',
    ORANGE_700 = '#7C4718',
    ORANGE_800 = '#5E3613',
    ORANGE_900 = '#44270D',

    YELLOW_100 = '#F8F6F1',
    YELLOW_200 = '#F9EDC8',
    YELLOW_300 = '#EDCC62',
    YELLOW_400 = '#D2AB52',
    YELLOW_500 = '#A1833F',
    YELLOW_600 = '#8C7236',
    YELLOW_700 = '#6B5729',
    YELLOW_800 = '#514220',
    YELLOW_900 = '#3B3017',

    GREEN_100 = '#E8F4EB',
    GREEN_200 = '#BDDEC4',
    GREEN_300 = '#97CCA3',
    GREEN_400 = '#7ABD88',
    GREEN_500 = '#4FA161',
    GREEN_600 = '#3E7D4B',
    GREEN_700 = '#2E5C38',
    GREEN_800 = '#214429',
    GREEN_900 = '#072C0F',

    PURPLE_100 = '#F6F1F9',
    PURPLE_200 = '#EBDEF2',
    PURPLE_300 = '#D7BCE6',
    PURPLE_400 = '#C8A3DC',
    PURPLE_500 = '#B27ECE',
    PURPLE_600 = '#985BB9',
    PURPLE_700 = '#753F93',
    PURPLE_800 = '#5B3172',
    PURPLE_900 = '#422353',

    PINK_600 = '#C1468E',
    PINK_700 = '#94316B',

    WHITE = '#ffffff',
    BLACK = '#000000',

    MALE = '#5296D5',
    FEMALE = '#D67C2E',
    NOT_DECLARED = '#31A3A3',

}
